import { Flex, FlexProps, Icon, Toggle, ToggleProps, Tooltip, TooltipContent, TooltipTrigger, Typography } from '@alpine-iq/ui-library';
import React from 'react';
import HelpTooltip from '../HelpTooltip';

type SettingsToggleProps = ToggleProps & {
	label: string;
	description?: React.ReactNode;
	reversed?: boolean;
	justify?: FlexProps['justify'];
	tooltip?: string;
	flexProps?: FlexProps;
};

export default function SettingsToggle({ tooltip, label, description, onChange, justify, reversed, flexProps, ...props }: SettingsToggleProps) {
	const toggle = (
		<Toggle
			{...props}
			onChange={(toggled: boolean) => {
				if (props.disabled) {
					return;
				}
				onChange?.(toggled);
			}}
		/>
	);

	const tooltipContent = tooltip ? <HelpTooltip tooltip={tooltip} /> : null;

	const labelContent = (
		<Flex
			direction="column"
			gap={4}
		>
			<Flex align="center">
				<Typography css={{ fontWeight: '500', lineHeight: '24px' }}>{label}</Typography>
				{tooltipContent}
			</Flex>
			{description && (
				<Typography
					variant="label"
					css={{ fontWeight: '500', lineHeight: '20px' }}
				>
					{description}
				</Typography>
			)}
		</Flex>
	);

	const toggleContent = tooltip ? (
		<Tooltip placement="top-start">
			<TooltipTrigger asChild>
				<div key={`${label}-toggle`}>{toggle}</div>
			</TooltipTrigger>
			<TooltipContent style={{ zIndex: 99999, maxWidth: '300px' }}>{tooltip}</TooltipContent>
		</Tooltip>
	) : (
		toggle
	);

	return (
		<Flex
			gap={24}
			{...flexProps}
			justify={justify ?? reversed ? 'flex-start' : 'space-between'}
		>
			{reversed ? [toggleContent, labelContent] : [labelContent, toggleContent]}
		</Flex>
	);
}
